import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c9a9400a")

_pushScopeId("data-v-c9a9400a")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { ref: "header" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("span", { "data-tooltip": "Koko" }, "Wardah"),
  /*#__PURE__*/_createTextVNode(" is a designer focused on creating user-centric experiences and eye-catching user interfaces. ")
], -1)
const _hoisted_5 = { ref: "projects" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h1", null, "PROJECTS", -1)
const _hoisted_8 = { class: "projects" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Scroll = _resolveComponent("Scroll")
  const _component_DownArrow = _resolveComponent("DownArrow")
  const _component_ProjectCard = _resolveComponent("ProjectCard")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("header", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Scroll, {
          class: "scroll-text",
          scrollWord: _ctx.scrollWord
        }, null, 8, ["scrollWord"]),
        _hoisted_4,
        _createVNode(_component_DownArrow, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollTo('projects')))
        })
      ])
    ], 512),
    _createVNode("section", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode("div", _hoisted_8, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
            return (_openBlock(), _createBlock("div", {
              key: project.id
            }, [
              _createVNode(_component_ProjectCard, { project: project }, null, 8, ["project"])
            ]))
          }), 128))
        ])
      ])
    ], 512)
  ]))
})